export default __webpack_public_path__ + "static/intro_back_1920-c370aa8dee50ce04efd1f281e2f15b6a.webp";